import React, { useState, useEffect } from 'react';
import { Box, Skeleton } from '@mui/material';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../../../../assets/style/sass/slick.scss';
// import { API } from '../../../../api';
import NewTaskCard from './NewTaskCard';
import ObjectiveCard from './ObjectiveCard';
import { useModule } from '../../../../utils/useModule';
import { levelTypes } from '../../../../utils/constants';
import { useAppSelector } from '../../../../redux/hooks';
// import { getUserDetails } from '../../../../utils/orgName';
import { getSlickSettings } from './Swiper/SlickSliderSetting';
import useProfileDetails from '../../../../hooks/useProfileDetails';

const CardSlider: React.FC<CardSliderProps> = ({ taskData, forMobile = false, loading, objData }) => {
  const [initialSlide, setInitialSlide] = useState(0);
  const [isDataReady, setIsDataReady] = useState(false);
  const selectedGroupId = useAppSelector((state) => state.selectedGroup.data);
  const [lastAddedObjectiveId, setLastAddedObjectiveId] = useState<string | null>(null);
  const [activeSlide, setActiveSlide] = useState(initialSlide);

  useEffect(() => {
    setActiveSlide(initialSlide);
  }, [initialSlide]);

  // const { orgId } = getUserDetails();
  // const grpId = selectedGroupId?.id;
  const { objectivesNumber } = useProfileDetails();
  const totalObjectivesCount = objectivesNumber || 3;
  const module = useModule();
  const isMentorship = module.isMentorship;
  const currentDate = Date.now() / 1000;
  const learningObjectives = objData || [];
  const getLevelActiveDate = (level: any) => {
    if (level?.startDate?.type === levelTypes.activeNow || !level?.startDate) return true;
    if (level?.startDate?.type === levelTypes.availableSoon) return false;
    if (level?.startDate?.type === levelTypes.calendarDate && currentDate >= level?.startDate?.value) return true;
    if (level?.startDate?.type === levelTypes.daysAfterSignup && currentDate >= level?.startDate?.value) return true;
    return false;
  };

  useEffect(() => {
    if (!isMentorship && taskData && taskData.length > 0) {
      let taskIndex = 0;
      let foundTodoTask = false;

      // Iterate through each level and task to find first non-green task
      for (const level of taskData) {
        if (getLevelActiveDate(level)) {
          for (const task of level.tasks) {
            if (!foundTodoTask && task.taskColor !== 'green') {
              foundTodoTask = true;
              setInitialSlide(taskIndex);
              break;
            }
            taskIndex++;
          }
          if (foundTodoTask) break;
        } else {
          // If we reach a locked level, set initial slide to current index
          setInitialSlide(taskIndex);
          break;
        }
      }

      // If all tasks are green (completed), show the first task
      if (!foundTodoTask) {
        setInitialSlide(0);
      }

      setIsDataReady(true);
    }
  }, [taskData, isMentorship]);

  useEffect(() => {
    if (isMentorship && learningObjectives && learningObjectives.length > 0) {
      if (lastAddedObjectiveId) {
        const newObjIndex = learningObjectives.findIndex((obj:any) => obj.id === lastAddedObjectiveId);
        if (newObjIndex !== -1) {
          setInitialSlide(newObjIndex);
          setLastAddedObjectiveId(null); 
          setIsDataReady(true);
          return;
        }
      }

      // // Priority 1: Show in-progress objectives first
      // const inProgressIndex = learningObjectives.findIndex(
      //   (objective: any) => objective.status === 'inprogress' && objective.objective
      // );

      // if (inProgressIndex !== -1) {
      //   setInitialSlide(inProgressIndex);
      //   setIsDataReady(true);
      //   return;
      // }

      // // Priority 2: Show to-do objectives
      // const todoIndex = learningObjectives.findIndex(
      //   (objective: any) => objective.status === 'to-do' && objective.objective
      // );

      // if (todoIndex !== -1) {
      //   setInitialSlide(todoIndex);
      //   setIsDataReady(true);
      //   return;
      // }

      // // Priority 3: Special case when we have one less than total count
      // if (learningObjectives.length === totalObjectivesCount - 1 && 
      //     learningObjectives.every((obj: any) => obj.objective)) {
      //   setInitialSlide(totalObjectivesCount - 1);
      //   setIsDataReady(true);
      //   return;
      // }

      setInitialSlide(0);
      setActiveSlide(0);
      setIsDataReady(true);
    }
  }, [learningObjectives, isMentorship, totalObjectivesCount, lastAddedObjectiveId]);

  // Fetch total objectives count
  // useEffect(() => {
  //   const fetchTotalObjectives = async () => {
  //     try {
  //       const response = await API.getLearningObjectives({ grpId, orgId });
  //       const count = response.data?.data?.learningObjectives?.number || 3;
  //       setTotalObjectivesCount(count);
  //     } catch (error) {
  //       console.error('Error fetching total learning objectives:', error);
  //     }
  //   };

  //   if (grpId && orgId) {
  //     fetchTotalObjectives();
  //   }
  // }, [grpId, orgId]);

  const getColor = (status: string) => {
    if (status === 'to-do') return 'grey';
    if (status === 'inprogress') return 'blue';
    return 'green';
  };

  let tasksCount = 0;
  if (taskData) {
    taskData.forEach((level: any) => {
      tasksCount += level.tasks.length;
    });
  }

  const objCount = learningObjectives.length;

  /** Render Objective cards for mentorship */
  const renderMentorshipCards = () => {
    const cards = [];
    const existingObjectives = learningObjectives.slice(0, totalObjectivesCount);

    cards.push(
      ...existingObjectives.map((objective: any, index: number) => {
        let noteCount = 0;
        if (Array.isArray(objective.notes)) {
          objective.notes.forEach((noteObject: any) => {
            if (noteObject.notes && Array.isArray(noteObject.notes)) {
              noteCount += noteObject.notes.length;
            } else {
              noteCount += 1;
            }
          });
        }
        
        return (
          <React.Fragment key={objective.id}>
            <ObjectiveCard
              key={objective.id}
              objId={objective.id}
              borderColor={getColor(objective.status)}
              title={objective.objective}
              description={objective.description}
              status={objective.status}
              current={index + 1}
              total={totalObjectivesCount}
              noteCount={noteCount}
              videoCount={objective.mentors?.reduce((acc: number, mentor: any) => acc + mentor.meetings.length, 0) || 0}
              notes={objective.notes || []}
              mentors={objective.mentors || []}
            />
          </React.Fragment>
        );
      })
    );

    const remainingSlots = totalObjectivesCount - existingObjectives.length;

    if (remainingSlots > 0) {
      for (let i = 0; i < remainingSlots; i++) {
        const currentPosition = existingObjectives.length + i + 1;
        if (currentPosition <= totalObjectivesCount) {
          cards.push(
            <React.Fragment key={`empty-${i}`}>
              <ObjectiveCard
                key={`empty-${i}`}
                objId=""
                borderColor="grey"
                title=""
                description=""
                status=""
                current={currentPosition}
                total={totalObjectivesCount}
                noteCount={0}
                videoCount={0}
                notes={[]}
                mentors={[]}
              />
            </React.Fragment>
          );
        }
      }
    }
    return cards;
  };

  /** Render Task cards */
  const renderTaskCards = () =>
    taskData.flatMap((level: any, levelIndex: number) => {
      if (!getLevelActiveDate(level)) {
        return (
          <React.Fragment key={level._id}>
            <NewTaskCard
              levelName={level.levelName}
              levelId={level._id}
              borderColor="grey"
              trophyColor="grey"
              isLocked={true}
              levelDescription={level?.levelDescription || 'This module has no description'}
              levelNumber={levelIndex + 1}
              level={level}
            />
          </React.Fragment>
        );
      }

      return level.tasks.map((task: any) => (
        <React.Fragment key={task.id}>
          <NewTaskCard
            task={task}
            levelName={level.levelName}
            levelId={level._id}
            borderColor={task.taskColor}
            trophyColor={task.taskColor}
            level={level}
          />
        </React.Fragment>
      ));
    });

  /** Get cards for the slider */
  const getCards = () => {
    const rawCards = isMentorship ? renderMentorshipCards() : renderTaskCards();
    // const limitedCards = limit ? rawCards.slice(0, limit) : rawCards;
    return rawCards.map((card: JSX.Element, index: number) => (
      // return limitedCards.map((card: JSX.Element, index: number) => (
      <Box key={index} px={1}>
        {card}
      </Box>
    ));
  };

  // Create slick settings with current initialSlide value
  const slickSettings = getSlickSettings({
    initialSlide,
    activeSlide,  
    setActiveSlide, 
    loading,
    cardCount: isMentorship ? totalObjectivesCount : tasksCount,
    totalCount: isMentorship ? totalObjectivesCount : undefined
  });

  /** Slider Loader */
  if (loading) {
    return (
      <Box position="relative" my={2}>
        <Slider {...slickSettings}>
          {[...Array(3)].map((_, index) => (
            <Box key={index} className={'loading-card-box'}>
              <Skeleton variant="rounded" width="100%" height="332px" />
            </Box>
          ))}
        </Slider>
      </Box>
    );
  }

  /** Data ready Time */
  if (!isDataReady && !loading) {
    return null;
  }

  /** Slider */
  return (
    <Box position="relative" my={2}>
      <Slider key={`slider-${initialSlide}-${isMentorship ? 'mentorship' : 'tasks'}-${learningObjectives.length}`} 
      {...slickSettings}>
        {getCards()}
      </Slider>
    </Box>
  );
};

export default CardSlider;
